import { CategoryFilter } from "components";

export function Category() {
  return (
    <div>
      <CategoryFilter />
    </div>
  );
}
